export default __webpack_public_path__ + "static/media/bounty-animations.544ae67f.gif";